export const infrastructureServiceMessages = {
  WORK_ORDERS: {
    SAVE_SUCCESS: 'workorders saved successfully',
    SAVE_ERROR: 'Unable to save workorders',
    GET_ERROR: 'Unable to get workorders',
    UPDATE_STATUS_ERROR: 'Unable to update workorder status',
    UPDATE_ERROR: 'Unable to update workorder',
  },
  CONTACTS: {
    GET_ERROR: 'Unable to get contacts',
    LOAD_MORE_ERROR: 'Unable to load more contact groups',
    GROUP_OPTIONS_ERROR: 'Unable to load contact groups for moving or duplicating',
    CREATE_SUCCESS: 'Contact created successfully',
    CREATE_ERROR: 'Unable to create contact',
    UPDATE_SUCCESS: 'Contact updated successfully',
    UPDATE_ERROR: 'Unable to update contact',
    DUPLICATE_SUCCESS: 'Contact duplicated successfully',
    DUPLICATE_ERROR: 'Unable to duplicate contact',
    MOVE_SUCCESS: 'Contact moved successfully',
    MOVE_ERROR: 'Unable to move contact',
    DELETE_SUCCESS: 'Contact deleted successfully',
    DELETE_ERROR: 'Unable to delete contact',
    CREATE_GROUP_SUCCESS: 'Group created successfully',
    CREATE_GROUP_ERROR: 'Unable to create group',
    RENAME_GROUP_SUCCESS: 'Group renamed successfully',
    RENAME_GROUP_ERROR: 'Unable to rename group',
    DELETE_GROUP_SUCCESS: 'Group deleted; its contacts were moved to Ungrouped',
    DELETE_GROUP_ERROR: 'Unable to delete group',
  },
  GEOSERVER: {
    STATS_ERROR: 'Unable to fetch stats',
  },
  ASSETS: {
    GET_ERROR: 'Unable to get AssetType and AssetId',
  },
};
